import React, { useState } from 'react'
import { useGameStore } from '../store/game-store'

export default function ChatOverlay(): React.ReactElement {
  const { messages, sendChat } = useGameStore()
  const [text, setText] = useState('')
  const [open, setOpen] = useState(false)
  const containerRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight
    }
  }, [messages.length])

  const handleSend = (): void => {
    if (!text.trim()) return
    sendChat(text.trim())
    setText('')
  }

  return (
    <div style={{
      position: 'absolute', bottom: 60, right: 8, zIndex: 15,
      display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4,
    }}>
      {open && (
        <div style={{
          width: 240, maxHeight: 200,
          background: 'rgba(0,0,0,0.85)', borderRadius: 10,
          border: '1px solid rgba(255,255,255,0.15)',
          display: 'flex', flexDirection: 'column', overflow: 'hidden',
        }}>
          <div ref={containerRef} style={{
            flex: 1, overflowY: 'auto', padding: '8px 10px', minHeight: 80,
            display: 'flex', flexDirection: 'column', gap: 4,
          }}>
            {messages.length === 0 && (
              <div style={{ fontSize: 11, color: '#666', textAlign: 'center', padding: 16 }}>
                No messages yet
              </div>
            )}
            {messages.slice(-30).map(msg => (
              <div key={msg.id} style={{ fontSize: 12, lineHeight: 1.4 }}>
                <span style={{ color: '#f5c518', fontWeight: 700 }}>{msg.name}: </span>
                <span style={{ color: '#ddd' }}>{msg.text}</span>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <input
              value={text}
              onChange={e => setText(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') handleSend() }}
              placeholder="Type a message..."
              maxLength={200}
              style={{
                flex: 1, padding: '8px 10px', border: 'none', outline: 'none',
                background: 'transparent', color: '#fff', fontSize: 12,
              }}
            />
            <button onClick={handleSend} style={{
              padding: '8px 12px', border: 'none', background: '#e8491d',
              color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer',
            }}>Send</button>
          </div>
        </div>
      )}
      <button onClick={() => setOpen(!open)} style={{
        padding: '8px 12px', border: 'none', borderRadius: 8,
        background: open ? '#e8491d' : 'rgba(0,0,0,0.6)',
        color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer',
        outline: '1px solid rgba(255,255,255,0.2)',
      }}>
        💬 {messages.length > 0 && <span style={{ fontSize: 10, opacity: 0.7 }}>({messages.length})</span>}
      </button>
    </div>
  )
}
